<div class="upSlider" [class.show]="showForm">
        <div class="slider-box">
            <div class="slider-header">
                <div (click)="closePopup()">
                    <img src="assets/img/gray-down-arrow.svg" alt="">
                </div>
                <h1 class="header1">{{title}}</h1>
            </div>
            <div *ngIf="showForm" class="slider-box-body" style="height: calc(100vh - 140px);">
                    <app-form-sections
                    (cancel)="closePopup()"
                    (onFormDone)="onFormSubmit($event)"
                    [sections]="sections$"
                    [isLoading]="isLoading">
                </app-form-sections>
            </div>
        </div>
  </div>
<app-snack-bar></app-snack-bar>
